<template>
<div >
  <div class="row">
        <div class="flex xs12 sm12 lg9">
          <h1>{{ $t('gestaocurso.CursosAndamento') }}</h1>
        </div>
        <div v-if="novo" class="flex xs12 sm12 lg3">
          <va-button class="text-right"   :color="BuNovo.color" :style="BuNovo"> {{ $t('Geral.Novo') }}</va-button>
        </div>
  </div>

  <div v-if="!novo">
         
              <div class="row">
                  <div v-if="!editar" class="flex md4 sm12 xs12">
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="oferta_grade_empresa.grade_curricular"
                      textBy="nome_curso"
                      :options="getAllGradeCurricular"
                      placeholder="Grade Curricular"
                    />  
                  </div>
                  
                    <div v-if="!editar" class="flex md3 sm12 xs12">
                        <va-input
                        :label="$t('forms.selects.simple')"
                          v-model="oferta_grade_empresa.data_abertura"
                         type="date"
                          placeholder="Fecha Inicio"
                        />
                    </div>
                    <div v-if="!editar" class="flex md3 sm12 xs12">
                        <va-input
                        :label="$t('forms.selects.simple')"
                          v-model="oferta_grade_empresa.data_encerramento"
                          type="date"
                          placeholder="Fecha Encerramento"
                        />
                    </div>
                    <div v-if="!editar" class="flex md2 sm12 xs12">
                        <va-input
                        :label="'Descricion'"
                          v-model="oferta_grade_empresa.nome"
                          placeholder="Descricion"
                        />
                      </div>

                    <div v-if="!editar" class="flex md4 sm12 xs12">
                    <va-select
                      label="Programa"
                      v-model="oferta_grade_empresa.arquivos_id"
                      textBy="nome"
                      :options="allArquivos"
                      placeholder="Programa Academico"
                    />  
                  </div>

                  <div v-if="editar" class="flex md4 sm12 xs12">
                    
                    <div class="form-group">
                      <label >Editar programa</label>
                      <select v-model="editar_arquivo_id" class="form-control">
                        <option></option>
                        <option v-for="(lista,index) in allArquivos" :key="index" :value="lista.id" >{{lista.nome}}</option>
                        
                      </select>

                       
                      
                   
                  </div>
                  
                  </div>
                </div>
                <div class="row">
                  <div class="flex md2 sm12 xs12 text-center">
                          <va-button @click="addNovo()" v-if="!editar" type="submit" class="text-right"   color="dark"> {{ $t('Geral.Salvar') }}</va-button>
                          <va-button @click="editarNovo()" v-if="editar" type="submit" class="text-right"   color="dark"> Guardar</va-button>
                      </div>

                </div>
        

  </div>
 
    <va-data-table
          :fields="fields"
          :data="getdados"
          hoverable
          no-pagination
          >
          
              <template slot="marker" slot-scope="props">
                <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
              </template>

              <template slot="actions" slot-scope="props">

                 <va-button flat small color="primary" @click="abrirpolos(props.rowData)" class="ma-0">
                  Polos
                </va-button>

                 <va-button flat small color="success" @click="abrirmaterias(props.rowData)" class="ma-0">
                  Matérias
                </va-button>

                <va-button flat small color="info" @click="Editar(props.rowData)" class="ma-0">
                  {{ $t('tables.edit') }}
                </va-button>

              </template>
              
        </va-data-table>

</div>

      
 
</template>

<script>

export default {
  name: 'cursosandamento',
  

  data () {
      return {
       editar:false,
       
        BuNovo: {
          color:'info',
          'width': '100%',
        }, 
        novo: false,
     
        oferta_grade_empresa:{
            grade_curricular:'',
            nome:'',
            data_abertura:'',
            data_encerramento:'',
            arquivos_id:''
          },
        editar_arquivo:{
            grade_curricular:'',
            nome:'',
            data_abertura:'',
            data_encerramento:'',
            arquivos_id:''
          },

      editar_arquivo_id:''
      
      }
    },
    created(){
      
      this.all();
      
  
    },
    computed: {
      
      allArquivos(){
         return this.$store.state.arquivos.allArquivosTipo   
      },

      getdados (){
          return this.$store.state.oferta_grade_empresa.ofertagradeempresa   
      },
      getAllGradeCurricular(){
        return this.$store.state.gradecurricular.gradecurricular   
      },
      
    fields () {
        return [{
          name: '__slot:marker',
          width: '30px',
          dataClass: 'text-center',
        }, {
          name: 'nome_curso',
          title: this.$t('Curso'),
        }, {
          name: 'nome_tipo_curso',
          title: this.$t('Tipo'),
        }, {
          name: 'nome',
          title: this.$t('tables.headings.name'),
        }, {
          name: 'data_abertura_tratado',
          title: this.$t('arealuno.Data_inicio'),
        },
         {
          name: 'data_encerramento_tratado',
          title: this.$t('arealuno.Data_termino'),
        }, {
          name: '__slot:actions',
          dataClass: 'text-right',
        }]
    },
  },

  methods: {

    all (){
      let arquivos = {
          tipo_arquivo_id:7
      }

      this.$store.dispatch('allOfertaGradeEmpresa')
      this.$store.dispatch('allGradeCurricular')
      this.$store.dispatch('allArquivosTipo',arquivos)
    
    },
    
    Editar (value) {

      this.editar = true
      this.editar_arquivo  = value
      

    },
    editarNovo () {

     console.log(this.editar_arquivo_id)
     let edit = {
       arquivos_id: this.editar_arquivo_id,
       id:this.editar_arquivo.id
     }
     console.log(edit)
      this.$store.dispatch('editarOfertaGradeEmpresa',edit)

      this.editar =false
      // this.oferta_grade_empresa = ''
      // this.editar_arquivo = ''

    },

    addNovo () {
      this.$store.dispatch('addOfertaGradeEmpresa',this.oferta_grade_empresa)

      this.oferta_grade_empresa = {
            grade_curricular:'',
            nome:'',
            data_abertura:'',
            data_encerramento:'',
            arquivos_id:''
          },
       this.all()

    },
     abrirpolos (value) {
      
      this.$store.dispatch('setGradeCurricular',value);
      this.$emit('trocar_component', 'polos');
      // this.$router.push({ name: 'login' })
      
      },
      abrirmaterias (value) {
     console.log(value)
      this.$store.dispatch('setGradeCurricular',value);
      this.$emit('trocar_component', 'datamateria');
     
      
      },

    tratarData(){
        
      console.log(this.formatDate('2018-04-01', 'pt-br'));

    },
    formatDate(data, formato) {
      if (formato == 'pt-br') {
        return (data.substr(0, 10).split('-').reverse().join('/'));
      } else {
        return (data.substr(0, 10).split('/').reverse().join('-'));
      }
    },
    
  },
}
</script>

<style lang="scss">

</style>
